import { Component, computed, input } from '@angular/core';
import { PortalTimeAgoPipe } from '@app/shared/pipes/portal-time-ago.pipe';
import { SharedModule } from '@app/shared/shared.module';
import { NotificationLiveViewItemComponent } from '@business/notification/components/notification-live-view/notification-live-view-item.component';
import { NotificationLiveViewTitleImageComponent } from '@business/notification/components/notification-live-view/notification-live-view-title-image.component';
import {
  normalizeNotification,
  PortalNotificationLike,
  SupportedPortalNotification,
} from '@business/notification/models/portal-notification-helpers';

@Component({
  selector: 'portal-notification-live-view',
  imports: [
    NotificationLiveViewItemComponent,
    SharedModule,
    NotificationLiveViewTitleImageComponent,
    PortalTimeAgoPipe,
  ],
  templateUrl: './notification-live-view.component.html',
  styleUrls: ['./notification-live-view.component.scss'],
})
export class NotificationLiveViewComponent {
  language = input<string>();
  notifications = input.required<SupportedPortalNotification | SupportedPortalNotification[]>();
  showPublicationDate = input.required<boolean>();
  showTitle = input.required<boolean>();

  normalizedNotifications = computed((): PortalNotificationLike[] => {
    const value = this.notifications();

    if (Array.isArray(value)) {
      return value.map((notification) => normalizeNotification(notification));
    } else {
      return [normalizeNotification(value)];
    }
  });
}
